import Vue from "vue";
import VueRouter from "vue-router";

import AdminRoutes from "../routes/admin/admin.routes";
import ApiService from "../services/api.services";
import GatewayService from "../services/gateway.services";
import { TokenService, leaveImpersonation } from "../services/auth/storage.services.js";
import store from "../store";
import NotificationRoutes from "./comum/notification.routes";
import FinancialRoutes from "./financial/financial.routes";
import FinancialTypeRoutes from "./financial/financial.type.routes";
import InvoiceRoutes from "./financial/invoice.routes";
import BankRoutes from "./register/bank.routes";
import BranchRoutes from "./register/branch.routes";
import ContractRoutes from "./register/contract.routes";
import CustomerRoutes from "./register/customer.routes";
import DeliveryRoutes from "./register/delivery.routes";
import DepartmentRoutes from "./register/department.routes";
import ExternalRoutes from "./register/external.routes";
import IntegrationRoutes from "./register/integration.routes";
import PackageTableRoutes from "./register/package.table.routes";
import PackingRoutes from "./register/packing.routes";
import PriceDeadlineRoutes from "./register/price.deadline.routes";
import PriceTableRoutes from "./register/price.table.routes";
import RoleRoutes from "./register/role.routes";
import ScheduleRoutes from "./register/schedule.routes";
import SenderRoutes from "./register/sender.routes";
import ServicesGroupRoutes from "./register/services.group.routes";
import ServicesRoutes from "./register/services.routes";
import UnitRoutes from "./register/unit.routes";
import PostOfficeBoxRoutes from "./register/post.office.box.routes";
import UserRoutes from "./register/user.routes";
import BudgetRoutes from "./services/budget.routes";
import ImportRoutes from "./services/import.routes";
import LoadObjectsRoutes from "./services/load.objects.routes";
import MessageRoutes from "./services/message.routes";
import OrderServicesRoutes from "./services/order.services";
import PdvRoutes from "./services/pdv.routes";
import PrePostRoutes from "./services/pre.post.services";
import ReverseLogisticsRoutes from "./services/reverse.logistics.routes";
import SearchOptionsRoutes from "./services/search.options.routes";
import TagsRoutes from "./services/tags.services";
import AttendanceRoutes from "./umov/attendance.routes";
import BookPhotosRoutes from "./umov/book.photos.routes";
import CallCenterRoutes from "./umov/call.center.routes";
import CouriersRoutes from "./umov/couriers.routes";
import ItemsRoutes from "./umov/items.routes";
import ReasonRoutes from "./umov/reason.routes";
import RouteRoutes from "./umov/route.routes";
import ScheduleAwayRoutes from "./umov/scheduled.away.routes";
import TeamRoutes from "./umov/team.routes";
import RequestInfoRoutes from './services/request.info.routes'
import ShippingRoutes from "./register/shipping.routes";

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  linkActiveClass: "active",
  routes: [
    ...AdminRoutes,
    ...SenderRoutes,
    ...UserRoutes,
    ...ServicesGroupRoutes,
    ...RoleRoutes,
    ...CustomerRoutes,
    ...DepartmentRoutes,
    ...BranchRoutes,
    ...OrderServicesRoutes,
    ...TagsRoutes,
    ...PrePostRoutes,
    ...DeliveryRoutes,
    ...ReverseLogisticsRoutes,
    ...ServicesRoutes,
    ...PackageTableRoutes,
    ...PriceTableRoutes,
    ...PriceDeadlineRoutes,
    ...PackingRoutes,
    ...MessageRoutes,
    ...ImportRoutes,
    ...LoadObjectsRoutes,
    ...SearchOptionsRoutes,
    ...FinancialTypeRoutes,
    ...ScheduleRoutes,
    ...FinancialRoutes,
    ...ContractRoutes,
    ...TeamRoutes,
    ...CouriersRoutes,
    ...RouteRoutes,
    ...AttendanceRoutes,
    ...CallCenterRoutes,
    ...ItemsRoutes,
    ...ReasonRoutes,
    ...ScheduleAwayRoutes,
    ...BookPhotosRoutes,
    ...BankRoutes,
    ...InvoiceRoutes,
    ...NotificationRoutes,
    ...BudgetRoutes,
    ...UnitRoutes,
    ...PostOfficeBoxRoutes,
    ...IntegrationRoutes,
    ...ExternalRoutes,
    ...PdvRoutes,
    ...RequestInfoRoutes,
    ...ShippingRoutes,
  ],
});

function parseJwt(token) {
  var base64Url = token.split(".")[1];
  var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  var jsonPayload = decodeURIComponent(
    Buffer.from(base64, "base64")
      .toString("ascii")
      .split("")
      .map(function (c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join("")
  );
  return JSON.parse(jsonPayload);
}

router.beforeEach((to, from, next) => {
  const isPublic = to.matched.some((record) => record.meta.public);
  if (!isPublic && !store.state.auth.accessToken) {
    return next({
      name: "login",
    });
  }
  if (store.state.auth.accessToken) {
    const jwtPayload = parseJwt(store.state.auth.accessToken);
    if (jwtPayload.exp < Date.now() / 1000) {
      if (TokenService.isImpersonating()) {
        return leaveImpersonation();
      }
      TokenService.removeToken();
      store.state.auth.accessToken = null;
      return next({
        name: "login",
      });
    }
    if (to.meta && to.meta.role && to.meta.role.length > 0) {
      const permission = to.meta.role.find((role) => role === jwtPayload.type || role === jwtPayload.roleId);
      if (!permission) {
        return next({
          name: "home",
        });
      }
    }
  }
  ApiService.setHeader();
  GatewayService.setHeader();
  next();
});

// Histórico de acessos recentes da home (localStorage — sem custo de backend).
// Guarda os últimos paths visitados; a home resolve os rótulos pelo menu do usuário.
router.afterEach((to) => {
  try {
    const isPublic = to.matched.some((record) => record.meta.public);
    if (!to.path || to.path === "/" || isPublic) {
      return;
    }
    const key = "xpost-recent-routes";
    const list = JSON.parse(localStorage.getItem(key) || "[]").filter((path) => path !== to.path);
    list.unshift(to.path);
    localStorage.setItem(key, JSON.stringify(list.slice(0, 8)));
  } catch (error) {
    // localStorage indisponível — histórico é opcional
  }
});

export default router;
